import { render, staticRenderFns } from "./GroupsForm.vue?vue&type=template&id=550b1536&scoped=true&"
import script from "./GroupsForm.vue?vue&type=script&lang=js&"
export * from "./GroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupsForm.vue?vue&type=style&index=0&id=550b1536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b1536",
  null
  
)

export default component.exports